import {
  AfterViewInit,
  Component,
  ComponentRef,
  inject,
  Injector,
  Input,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { DialogService, SolComponentEntry } from '../../../services/dialog.service';
import { DIALOG_CLOSE } from '../abstract-dialog-component.directive';
import { SolDialogContainerState } from './sol-dialog-container.state';

@Component({
  selector: 'sol-dialog-container',
  templateUrl: './sol-dialog-container.component.html',
  host: { class: 'sol-dialog-container-content' },
})
export class SolDialogContainerComponent extends AbstractComponent<SolDialogContainerState> implements AfterViewInit {
  private readonly dialogService = inject(DialogService);
  private readonly injector = inject(Injector);

  @ViewChild('dialogContent', { read: ViewContainerRef }) private dialogContainer!: ViewContainerRef;
  private componentRef: ComponentRef<any> | undefined;

  constructor() {
    super(SolDialogContainerState.of());
  }

  @Input()
  public set entry(entry: SolComponentEntry) {
    this.update(s => s.withEntry(entry));
  }

  public ngAfterViewInit(): void {
    this.updateDialogComponent();
  }

  private updateDialogComponent(): void {
    const entry = this.state.entry;
    if (!entry || !this.dialogContainer) return;

    if (this.dialogContainer.length === 0) {
      const injector = Injector.create({
        providers: [{ provide: DIALOG_CLOSE, useValue: () => this.dialogService.closeEntry(entry.id) }],
        parent: this.injector,
      });
      this.componentRef = this.dialogContainer.createComponent(entry.componentType, { injector });
      entry.configurer(this.componentRef.instance);
      this.dialogService.register(entry.id, this.componentRef.instance);
    }
  }
}
